import type { CouponRecord } from '@navio/nsdk';
import { NoddiColumnDef } from 'noddi-ui-web';
import { formatCurrencyAmount } from 'noddi-util';
import { CustomerInfoCell } from '../UserGroups/CustomerInfoCell';
import { COUPON_SOURCE_LABEL, couponSourceKind } from './Coupon/couponSourceCopy';
import { CouponSourceCell } from './CouponSourceCell';

const discountColumn: NoddiColumnDef<CouponRecord> = {
  header: 'Discount',
  accessorFn: (row) =>
    row.discount && row.discount.amount > 0
      ? formatCurrencyAmount({ money: row.discount })
      : `${row.discountPercentage ?? 0} %`
};

const sharedCouponColumns: NoddiColumnDef<CouponRecord>[] = [
  {
    header: 'Name',
    accessorKey: 'namePublic'
  },
  discountColumn,
  {
    header: 'Expires',
    accessorKey: 'expiresAt',
    meta: { type: 'date-time' }
  },
  {
    header: 'Used',
    accessorKey: 'usedAt',
    meta: { type: 'date-time' }
  },
  {
    header: 'Source',
    accessorFn: (row) => COUPON_SOURCE_LABEL[couponSourceKind(row)],
    cell: ({ row }) => <CouponSourceCell coupon={row.original} />
  }
];

type BuildCouponColumnsArgs = {
  includeCustomer?: boolean;
};

export const buildCouponColumns = ({
  includeCustomer = true
}: BuildCouponColumnsArgs = {}): NoddiColumnDef<CouponRecord>[] => {
  if (!includeCustomer) {
    return sharedCouponColumns;
  }

  return [
    {
      header: 'Customer',
      accessorFn: (row) => row.userGroup?.name ?? null,
      cell: ({ row }) => (row.original.userGroup ? <CustomerInfoCell userGroup={row.original.userGroup} /> : null)
    },
    ...sharedCouponColumns
  ];
};

/** Customer detail Coupons tab — customer is already known. */
export const customerCouponColumns = buildCouponColumns({ includeCustomer: false });
